import { Link } from "wouter";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-heading font-bold text-primary mb-4">Therapy Hub</h3>
            <p className="text-gray-600 text-sm">
              Plataforma de terapia online para cuidar da sua saúde mental com profissionais qualificados.
            </p>
          </div>
          
          <div>
            <h4 className="font-medium mb-4">Links Rápidos</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link href="/therapists">
                  <a className="text-gray-600 hover:text-primary transition-colors">Nossos Terapeutas</a>
                </Link>
              </li>
              <li>
                <Link href="/booking">
                  <a className="text-gray-600 hover:text-primary transition-colors">Como Funciona</a>
                </Link>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-primary transition-colors">Preços</a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-primary transition-colors">FAQ</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-medium mb-4">Suporte</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="text-gray-600 hover:text-primary transition-colors">Contato</a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-primary transition-colors">Central de Ajuda</a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-primary transition-colors">Política de Privacidade</a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-primary transition-colors">Termos de Uso</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-medium mb-4">Contato</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center text-gray-600">
                <i className="fas fa-envelope mr-2 text-primary"></i>
                contato@therapyhub.com.br
              </li>
              <li className="flex items-center text-gray-600">
                <i className="fas fa-phone mr-2 text-primary"></i>
                (11) 3456-7890
              </li>
            </ul>
            <div className="mt-4 flex space-x-4">
              <a href="#" className="text-gray-500 hover:text-primary transition-colors">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="text-gray-500 hover:text-primary transition-colors">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="#" className="text-gray-500 hover:text-primary transition-colors">
                <i className="fab fa-youtube"></i>
              </a>
              <a href="#" className="text-gray-500 hover:text-primary transition-colors">
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-6 border-t border-gray-200 text-sm text-center text-gray-600">
          &copy; {new Date().getFullYear()} Therapy Hub. Todos os direitos reservados.
        </div>
      </div>
    </footer>
  );
}
